import { useInstance } from "@meraki-internal/react-dependency-injection";
import { useState } from "react";
import { HealthStatusAndMessage } from "./HealthStatusAndMessage";
import { IonButton } from "@ionic/react";
import { ClubsState } from "./ClubsState";

export const ClubHealthCard: React.FC<{ clubId: string; }> = ({ clubId }) => {
    const clubsState = useInstance(ClubsState);

    const club = clubsState.getClub(clubId);

    const modelHealth = club.health;

    const [formHealth, setHealth] = useState(modelHealth);

    const isDirty = JSON.stringify(modelHealth) !== JSON.stringify(formHealth);

    return (
        <div className="club-health-card">
            <h1>{club.name}</h1>
            <div className="volunteer-health">
                {/* TODO: default should be driven by API now */}
                {/* TODO: on click, give me a popover to pick from the three, with hints about when to pick each */}
                <HealthStatusAndMessage
                    statusType='volunteer'
                    status={formHealth.volunteerStatus || 'danger'}
                    message={formHealth.volunteerStatusMessage || ''}
                    onChange={({ status, message }) => {
                        setHealth(health => ({
                            ...health,
                            volunteerStatus: status,
                            volunteerStatusMessage: message
                        }));
                    }}
                />

                {/* TODO: default should be driven by API now */}
                {/* TODO: on click, turn it into a text area so I can change it, on blur, save */}

            </div>
            <div className="funding-health">
                <HealthStatusAndMessage
                    statusType='funding'
                    status={formHealth.fundingStatus || 'danger'}
                    message={formHealth.fundingStatusMessage || ''}
                    onChange={({ status, message }) => {
                        setHealth(health => ({
                            ...health,
                            fundingStatus: status,
                            fundingStatusMessage: message
                        }));
                    }}
                />
            </div>
            <div className="location-health">
                <HealthStatusAndMessage
                    statusType='lab'
                    status={formHealth.labStatus || 'danger'}
                    message={formHealth.labStatusMessage || ''}
                    onChange={({ status, message }) => {
                        setHealth(health => ({
                            ...health,
                            labStatus: status,
                            labStatusMessage: message
                        }));
                    }}
                />
            </div>
            <div>
                <IonButton fill="outline" onClick={() => {
                    window.location.hash = `/clubs/${clubId}`;
                }}>
                    Cancel
                </IonButton>
                <IonButton
                    disabled={!isDirty}
                    onClick={async () => {
                        await clubsState.saveClubHealth(clubId, formHealth);


                        window.location.hash = `/clubs/${clubId}`;
                    }}
                >
                    Save
                </IonButton>
            </div>
        </div>
    );
}